var rs = require('jsrsasign')
const TokenKey = 'ldms_user_token'
const RefreshTokenKey = 'ldms_user_refresh'

export function getToken () {
  return {
    accessToken: localStorage.getItem(TokenKey),
    refreshToken: localStorage.getItem(RefreshTokenKey)
  }
}

export function setToken (accessToken, refreshToken) {
  localStorage.setItem(TokenKey, accessToken)
  localStorage.setItem(RefreshTokenKey, refreshToken)
}

export function removeToken () {
  localStorage.clear()
}

export function refreshTokenIsUse () {
  if (getToken().refreshToken != null) {
    try {
      let a = getToken().refreshToken.split('.')
      let uClaim = rs.b64utoutf8(a[1])
      let pClaim = rs.KJUR.jws.JWS.readSafeJSONString(uClaim)
      let date = new Date().getTime()
      return date < pClaim.exp * 1000
    } catch (e) {
      return false
    }
  }
  return false
}

export function tokenIsUse () {
  if (getToken().accessToken != null) {
    try {
      let a = getToken().accessToken.split('.')
      let uClaim = rs.b64utoutf8(a[1])
      let pClaim = rs.KJUR.jws.JWS.readSafeJSONString(uClaim)
      let date = new Date().getTime()
      return date < pClaim.exp * 1000
    } catch (e) {
      return false
    }
  }
  return false
}
